import React from 'react'

import ReactMarkdown from 'react-markdown'

import style from './ReviewTable.module.css'

import { Task } from 'common/types/entities'
import { ResultType } from 'features/exam/exam-slice'

type PropsType = {
  results: ResultType[]
  tasks: Task[]
}

export const ReviewTable = ({ results, tasks }: PropsType) => {
  return (
    <table className={style.table}>
      <thead>
        <tr>
          <th className={style.th}>
            <span>Вопрос</span>
          </th>
          <th className={style.th}>Неверный ответ</th>
        </tr>
      </thead>
      <tbody>
        {results.map((result, index) => {
          if (result.status === false) {
            let tdText: string

            const task = tasks.find(task => task.id === result.taskId)
            const rightAnswersId = task?.answers
              ?.filter(answer => answer.isCorrect)
              .map(answer => answer.id)

            if (result.answers.every(id => rightAnswersId?.includes(id))) {
              tdText = 'Ответ неполный'
            } else {
              tdText = result.answers
                .map(id => task?.answers.find(answer => answer.id === id)!.text)
                .join(', ')
            }

            return (
              <tr key={index}>
                <td className={style.td}>{index + 1}</td>
                <td className={`${style.td} ${style[`td-answer`]} ${style['td-answer--mistake']}`}>
                  <ReactMarkdown className={style.markdown}>{tdText}</ReactMarkdown>
                </td>
              </tr>
            )
          }
        })}
      </tbody>
    </table>
  )
}
